import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const GateAddModalForm = ({
  listing,
  device,
  setDevice,
  setOpenGateAddModal,
  getGateLists,
  changeStatus,
  setChangeStatus
}) => {
  const [deviceId, setDeviceId] = useState("");
  const [deviceLabel, setDeviceLabel] = useState("");
  const [isLoading, setIsLoading] = useState(false)

  const cancel = () => {
    setOpenGateAddModal(false)
    setChangeStatus(false)
    setDeviceId("")
    setDeviceLabel("")
    setDevice(null)
  };


  useEffect(() => {
    if (device) {
      setDeviceId(device.device_id)
      setDeviceLabel(device.device_label)
    }
  }, [device])

  const onSave = () => {
    setIsLoading(true)
    axios.put(`${process.env.REACT_APP_API_URL}/gates`, {
      listing_id: listing?.listing_id,
      ...(!device && { device_id: deviceId}),
      device_label: deviceLabel,
      ...(device && { gate_id: device?.id })
    }).then(() => {
      getGateLists()
      toast.success(`Gate Device ${device ? "Edited" : "Added"} Successfully`)
      setOpenGateAddModal(false)
      setIsLoading(false)
    }).catch((err) => {
      setIsLoading(false)
      if (err && err.response && err.response?.data && err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error(`Error ${device ? "Updating" : "Adding"} Gate Device`)
      }
    });
  }
  const onChangeStatus = () => {
    setIsLoading(true)
    axios
      .patch(`${process.env.REACT_APP_API_URL}/gates/${device?.id}`, {
        is_active: !device?.is_active
      })
      .then(() => {
        getGateLists()
        toast.success(`Gate Device ${device?.is_active ? "Disabled" : "Enabled"} Successfully`)
        setOpenGateAddModal(false)
        setChangeStatus(false)
        setIsLoading(false)
      })
      .catch((err) => {
        setIsLoading(false)
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Error changing gate device status");
        }
      });
  }

  return (
    <>
      {changeStatus ?
        <div className="kt_body">
          <h4>
            Are you sure you want to{" "}
            <span className={`${device?.is_active ? "text-danger" : "text-success"} fw-bold`}>
              {device.is_active ? "Disable" : "Enable"}
            </span>
          </h4>
        </div>
        :
        <div className="kt_body">
          <div className="input-search mb-5">
            <label className="form-label fs-6 fw-bold">Device Label</label>
            <input
              type="text"
              data-kt-user-table-filter="search"
              className="form-control form-control-solid w-100 "
              placeholder="Enter Device Label"
              value={deviceLabel}
              onChange={(e) => setDeviceLabel(e.target.value)}
            />
          </div>
          {!device && <div className="input-search mb-5">
            <label className="form-label fs-6 fw-bold">Device ID</label>
            <input
              type="text"
              data-kt-user-table-filter="search"
              className="form-control form-control-solid w-100 "
              placeholder="Enter Device Id"
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value)}
            />
          </div>
          }
        </div>
      }
      <div className="text-center pt-5">
        {device && !changeStatus && <button
          type="reset"
          disabled={isLoading}
          onClick={() => setChangeStatus(true)}
          className={`btn ${!device?.is_active ? 'btn-success' : 'btn-danger'} me-3`}
          data-kt-users-modal-action="cancel"
        >
          {device.is_active ? 'Disable Gate' : 'Enable Gate'}
        </button>
        }
        <button
          type="reset"
          onClick={() => {
            if (changeStatus) {
              setChangeStatus(false)
            } else {
              cancel()
            }
          }}
          className="btn btn-light me-3"
          data-kt-users-modal-action="cancel"
        >
          Discard
        </button>
        {changeStatus && device && <button
          type="reset"
          disabled={isLoading}
          onClick={() => onChangeStatus()}
          className={`btn ${!device?.is_active ? 'btn-success' : 'btn-danger'} me-3`}
          data-kt-users-modal-action="cancel"
        >
          {device.is_active ? 'Disable Gate' : 'Enable Gate'}
        </button>
        }
        {!changeStatus && <button
          type="submit"
          className="btn btn-main text-white"
          data-kt-users-modal-action="submit"
          disabled={!deviceId || !deviceLabel || isLoading}
          onClick={onSave}
        >
          {device ? 'Edit Gate' : 'Add Gate'}
        </button>
        }
      </div>
    </>
  );
};

export { GateAddModalForm };
